package er.prateek.crossly.data.model.math

import er.prateek.crossly.data.model.SavedCellFill
import kotlinx.serialization.Serializable

/**
 * A resumable math-crossword attempt. The exact generated [puzzle] is stored (math content is
 * generated fresh per attempt, so it can't be re-derived from the level id alone), along with the
 * player's fills and counters. Persisted under its own key, independent of the crossword resume.
 */
@Serializable
data class SavedMathSession(
    val levelId: String,
    val index: Int,
    val puzzle: MathPuzzle,
    val fills: List<SavedCellFill> = emptyList(),
    val hintsUsed: Int = 0,
    val mistakes: Int = 0,
    val elapsedMs: Long = 0,
    val selectedRow: Int? = null,
    val selectedCol: Int? = null,
)
